import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Button } from "../ui/button";
import { useAuth } from "../../context/AuthContext";

const STATUS_STAGES = [
  "Lead", "Contacted", "Interested", "Proposal", "Paid", "Onboarding",
  "Building", "Internal Review", "Client Review", "Revision", "Approved",
  "Published", "Maintenance",
];

export function StatusBadge({ status }) {
  const color = {
    Lead: "bg-[#1b1b1d] text-[#D2CAB2]", Contacted: "bg-[#1b1b1d] text-[#D2CAB2]",
    Interested: "bg-amber-100 text-amber-700", Proposal: "bg-amber-100 text-amber-700",
    Paid: "bg-emerald-100 text-emerald-700", Onboarding: "bg-blue-100 text-blue-700",
    Building: "bg-blue-100 text-blue-700", "Internal Review": "bg-indigo-100 text-indigo-700",
    "Client Review": "bg-violet-100 text-violet-700", Revision: "bg-orange-100 text-orange-700",
    Approved: "bg-green-100 text-green-700", Published: "bg-green-600 text-white",
    Maintenance: "bg-teal-100 text-teal-700",
  }[status] || "bg-[#1b1b1d] text-[#D2CAB2]";
  return <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${color}`}>{status}</span>;
}

export { STATUS_STAGES };

export default function DashboardLayout({ title, children, actions }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0c0c0d]">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#141414]/80 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-display text-lg font-bold text-[#F3EDDC]">
            <img src="/logo.png" alt="WebLaunch Studio" className="h-8 w-8 rounded-md object-cover ring-1 ring-[#C9A227]/40" />
            WebLaunch
            <span className="ml-2 rounded-full bg-[#1b1b1d] px-2 py-0.5 text-xs font-medium text-[#948C79] capitalize">{user?.role}</span>
          </Link>
          <div className="flex items-center gap-3">
            <span className="hidden sm:block text-sm text-[#B7AF98]">{user?.name || user?.email}</span>
            <Button data-testid="logout-btn" variant="outline" size="sm" className="rounded-full" onClick={() => { logout(); navigate("/"); }}>
              <LogOut className="h-4 w-4 mr-1" /> Log out
            </Button>
          </div>
        </div>
      </header>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-10">
        <div className="flex items-center justify-between flex-wrap gap-4 mb-8">
          <h1 className="font-display text-3xl font-bold tracking-tight text-[#F3EDDC]">{title}</h1>
          {actions}
        </div>
        {children}
      </div>
    </div>
  );
}
